import { postApi } from "@/axios/interceptors";
export default {
  SetCustomerRepair(data: any) {
    return postApi.post("/repair/SetCustomerRepair", data);
  },
  GetRepair(data: any) {
    return postApi.post("/repair/getRepair", data);
  },
  GetRepairDetail(data: any) {
    return postApi.post("/repair/getRepairDetail", data);
  },
};
